<template>
    <div class="party-form entity-form" @click.stop>
        <div class="form-heading">
            <button class="button-primary button-primary__thin" type="button" @click="cancelForm">{{$t('form.party.cancel')}}</button>
            <div v-if="reference < 0" class="form-title">{{$t('form.party.newParty')}}</div>
            <div v-else class="form-title">{{$t('form.party.editParty')}}</div>
            <button class="button-primary button-primary__inverse button-primary__thin" @click="triggerPartySubmit">{{$t('form.party.save')}}</button>
        </div>

        <PartySettings :preselectedHostOnly="reference" :preselectedDate="preselectedDate" :preselectedHost="preselectedHost || reference" @save="submitParty" :party="null" ref="form" @create-host="createHost" />
    </div>
</template>

<script>
import PartySettings from '@/components/forms/PartySettings.vue'

export default {
    name: "PartyForm",
    components: { PartySettings },
    emits: ['party-submitted', 'add-component-clicked', 'form-closed'],
    props: {
        reference: { type: Number, default: -1 },
        preselectedDate: { type: Date, default: Date.now() },
        preselectedHost: { type: Number, default: -1 },

    },
    methods: {
        triggerPartySubmit(){
            if(this.$refs.form){
                this.$refs.form.submitParty()
            }
        },
        submitParty(payload){
            if(!this.$refs.form.validate()){
                return
            }
            this.$emit('party-submitted', payload)
        },
        createHost(){
            this.$emit('add-component-clicked', 'customer')
        },
        cancelForm(){
            this.$emit('form-closed')
        }
    }
}
</script>

<style scoped>

</style>
